import React, { useEffect } from "react";
import numeral from "numeral";

import graph_png from "../assets/graph.png";
import { useNavigate } from "react-router-dom";
import { TwListBox } from "./tailwind";
import { FunnelIcon } from "lucide-react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

numeral.register("locale", "fr", {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€',
  },
});

numeral.locale("fr");

export default function StatBox(item) {
  const { bgColor, title, img, icon, update, data, fullData } = item
  const navigate = useNavigate();
  const [filterList, setFilterList] = React.useState([]);
  const [dataFilter, setDataFilter] = React.useState({ value: "today" });
  const [dataNumbers, setDataNumbers] = React.useState(data);
  useEffect(() => {
    if (fullData.totalRevenue) {
      setDataNumbers(fullData.totalRevenue)
    }
  }, [fullData])
  useEffect(() => {
    if (Object.keys(fullData).length > 0) {
      if (title === "Members") {
        let list = [
          // { value: "all", title: "All Time", text: fullData.totalMembers },
          { value: "today", title: "today", textNumber: `+${fullData.todayMembers}`, text: ` today` },
          { value: "week", title: "this week", textNumber: `+${fullData.weekMembers}`, text: ` this week` },
          { value: "month", title: "this month", textNumber: `+${fullData.monthMembers}`, text: ` this month` },
        ]
        setFilterList(list)
        setDataFilter(list[1])
      } else if (title === "Bookings") {
        let list = [
          // { value: "all", title: "All Time", text: fullData.totalBookings },
          { value: "today", title: "today", textNumber: `+${fullData.todayBookings}`, text: ` today` },
          { value: "week", title: "this week", textNumber: `+${fullData.weekBookings}`, text: ` this week` },
          { value: "month", title: "this month", textNumber: `+${fullData.monthBookings}`, text: ` this month` },
        ]
        setFilterList(list)
        setDataFilter(list[1])
      } else if (title === "Revenue") {
        let list = [
          // { value: "all", title: "All Time", text: fullData.totalRevenue },
          { value: "today", title: "today", textNumber: `+ €${fullData.todayRevenue}`, text: ` today` },
          { value: "week", title: "this week", textNumber: `+ €${fullData.weekRevenue}`, text: ` this week` },
          { value: "month", title: "this month", textNumber: `+ €${fullData.monthRevenue}`, text: ` this month` },
        ]
        setFilterList(list)
        setDataFilter(list[1])
      } else {
        setFilterList([])
      }
    }
  }, [title, fullData])
  useEffect(() => {
    if (fullData) {
      if (dataFilter.value == "all") {
        setDataNumbers(fullData.totalRevenue)
      } else if (dataFilter.value == "today") {
        setDataNumbers(fullData.todayRevenue)
      } else if (dataFilter.value == "week") {
        setDataNumbers(fullData.weekRevenue)
      } else if (dataFilter.value == "month") {
        setDataNumbers(fullData.monthRevenue)
      }
    }
  }, [dataFilter])

  return (
    <div
      className={`w-full [max-w-sm] min-h-40 lg:min-h-48 ${bgColor} bg-no-repeat bg-right-bottom bg-local bg-cover text-white rounded-2xl relative`}
      style={{ backgroundImage: `url(${graph_png})` }}
    >
      {/* <div className={"flex justify-center"}>
        <img
          className={"object-cover w-full h-full absolute"}
          src={graph_png}
          alt={""}
        />
      </div> */}
      <div className={"h-full flex flex-col justify-between gap-2 px-6 py-4"}>
        <div className={"flex justify-between items-center gap-2"}>
          <h1 className={"font-semibold text-2xl"} >
            {title}
          </h1>
          {item.icon && (<item.icon
            className={
              'size-6 shrink-0'
            }
          />)}
          {img && (<img
            className={
              "size-4 md:size-6"
            }
            src={img}
            alt={""}
          />)}
        </div>

        <div className="flex-1 flex flex-col gap-2 items-start">
          <div className={"stat-value text-5xl font-semibold w-full line-clamp-1"} >
            {/* {title === "Revenue" ? (<>€&nbsp;{parseFloat(dataNumbers).toFixed(2)}</>) : numeral(data).format(title === "Revenue" ? "$0 a" : "0 a")} */}
            {title === "Revenue" ? (<>€&nbsp;{parseFloat(data).toFixed(2)}</>) : numeral(data).format(title === "Revenue" ? "$0 a" : "0 a")}
          </div>

          <div className={"flex gap-2 text-sm text-white justify-start w-full -mt-1"} >
            {filterList.length > 0 && (<Menu as="div" className="relative inline-flex text-left">
              <div>
                <MenuButton className="inline-flex [w-full] justify-center gap-x-1.5 rounded-md [bg-white] [px-1.5 py-1] text-sm font-semibold text-white [hover:text-gray-900 hover:bg-gray-50][shadow-sm] ring-0 ring-inset ring-gray-300 ">
                  <div className="inline-flex gap-x-1 justify-center items-center">
                    <span className="text-lg font-bold">
                      {dataFilter?.textNumber || ""}
                    </span>
                    <div className="inline-flex rounded-md text-sm px-1.5 py-1 [bg-white] text-gray-50 hover:text-gray-900 hover:bg-gray-50 ">
                      {dataFilter?.text || ""}
                      <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 [text-gray-400]" />
                    </div>
                  </div>
                </MenuButton>
              </div>

              <MenuItems
                transition
                className="absolute right-0 z-10 mt-8 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="py-1">
                  {filterList.map((opt, idx) => (
                    <MenuItem key={idx}><button
                      type="button"
                      onClick={() => {
                        setDataFilter(opt)
                      }}
                      className="w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                    >
                      {opt.title}
                    </button></MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Menu>)}
            {/* <TwListBox
              value={dataFilter}
              options={[
                { value: "all", title: "All Time" },
                { value: "today", title: "Since Yesterday" },
                { value: "week", title: "Since Last week" },
                { value: "month", title: "Since Last month" },
              ]}
              selectClassNmae={"bg-[#F0EAF7]  text-gray-900 hover:!text-brown-coffee"}
              // selectLabelClassNmae={"!text-white hover:!text-brown-coffee"}
              // dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-4 text-brown-coffee forced-colors:text-[Highlight]" />)}
              onChange={(v) => {
                setDataFilter(v.value)
              }}
            /> */}
          </div>
          <div className={"flex gap-2 text-sm text-white justify-end w-full"} >
            <button type="button" className={"w-auto rounded-md px-1.5 py-1 text-sm text-white hover:text-brown-coffee hover:bg-white/80 inline-flex items-center cursor-pointer"}
              onClick={() => {
                if (title === "Members") {
                  navigate("/mymembers", { replace: true });
                } else if (title === "Bookings") {
                  navigate("/all-bookings", { replace: true });
                } else if (title === "Revenue") {
                  navigate("/transactions", { replace: true });
                }
              }}
            >
              View all <ChevronRightIcon aria-hidden="true" className="-mr-1 size-5 [text-gray-400]" />
            </button>
          </div>
        </div>

        {/* {title === "Revenue" ? (
          <div className="flex-1 flex flex-col gap-2 items-start">
            <div className={"stat-value text-4xl font-semibold w-full line-clamp-1"} >
              {title === "Revenue" ? `€&nbsp;${parseFloat(dataNumbers).toFixed(2)}` : numeral(data).format(title === "Revenue" ? "$0 a" : "0 a")}
            </div>
            <button type="button" className={"w-auto text-blue-900"}
              onClick={() => {
                navigate("/transactions", { replace: true });
              }}
            >
              View details
            </button>
            <div className={"flex gap-2 text-sm text-white justify-end w-full"} >
              <TwListBox
                value={dataFilter}
                options={[
                  { value: "all", title: "All Time" },
                  { value: "today", title: "Since Yesterday" },
                  { value: "week", title: "Since Last week" },
                  { value: "month", title: "Since Last month" },
                ]}
                selectClassNmae={"bg-[#F0EAF7]  text-gray-900 hover:!text-brown-coffee"}
                // selectLabelClassNmae={"!text-white hover:!text-brown-coffee"}
                // dropdownArrow={(<FunnelIcon aria-hidden="true" className="size-4 text-brown-coffee forced-colors:text-[Highlight]" />)}
                onChange={(v) => {
                  setDataFilter(v.value)
                }}
              />
            </div>
          </div>
        ) : (<div className="flex-1">
          <div className={"stat-value text-4xl font-semibold w-full line-clamp-1"} >
            {numeral(data).format(title === "Revenue" ? "$0 a" : "0 a")}
          </div>
        </div>)} */}
        <div className={"flex justify-between items-center gap-2"}>
          {title !== "Revenue" ? (<div className={"stat-value text-4xl font-semibold"} >
            {/* {numeral(data).format(title === "Revenue" ? "$0 a" : "0 a")} */}
          </div>) : (<div className={"stat-value text-4xl font-semibold"} >

          </div>)}
          <div className={""} >
            {update}
          </div>
        </div>
      </div>
    </div>
  );
}
